$(document).on('click', '.close-ajax--cart,#site-overlay', function() {
   $('#ajax-cart').removeClass('opened-drawer');
   $('#site-overlay').removeClass('overlay--body');
});  
window.addEventListener('DOMContentLoaded', () => {
  if (window.globalVariables && window.globalVariables.cart) {
    const cartItems = window.globalVariables.cart.items;
    const cartVariantIds = cartItems.map(item => item.id);
    window.cartVariantIds = cartVariantIds;
    const formattedIds = cartVariantIds.map(id => `${id}-sample_cart`);
    const anchorTags = document.querySelectorAll('a');

    anchorTags.forEach(anchor => {
      const anchorId = anchor.getAttribute('id');
      formattedIds.forEach(formattedId => {
        if ((anchorId && anchorId.includes(formattedId))) {
          $(`#${anchorId}`).attr('disabled', true);
        }
      });
    });
  }
});
function sampleCart(id) {
                let group_id = `group_${id}_sample`; 
                  let formData = {
                               id: id,
                               quantity: 1,
                               properties:
                                {
                                  "_group_id": group_id
                                }
                  };
              $.ajax({
                   url: '/cart/add',
                   type: 'POST',
                   data: formData,
                  success: function(response){
     if (window.globalVariables && window.globalVariables.cart.items) {
    const cartItems = window.globalVariables.cart.items;
    const cartVariantIds = cartItems.map(item => item.id);
    window.cartVariantIds = cartVariantIds;
    const formattedIds = cartVariantIds.map(id => `${id}-sample_cart`);
    const anchorTags = document.querySelectorAll('a');
    let matchFound = false;
    anchorTags.forEach(anchor => {
      const anchorId = anchor.getAttribute('id');
      formattedIds.forEach(formattedId => {
        if ((anchorId && anchorId.includes(formattedId))) {
          $(`#${anchorId}`).attr('disabled', true);
          matchFound = true;
        }
      });
    });
    if (!matchFound) {
                $.ajax({
                      url: '/?section_id=component-cart-drawer',
                      type: 'GET',
                      dataType: 'html',
                      success: function(carthtml){
                           let cartFormHtml = $(carthtml).find('cart-form').prop('outerHTML');
                           $('cart-form').replaceWith(cartFormHtml);
                          $('.cart-drawer').addClass('opened-drawer');
                          $('#site-overlay').addClass('overlay--body');   
                          $(`#${id}-sample_cart`)
                            .attr('disabled', true) 
                      }
              })
  }
  } else {
                         $.ajax({
                      url: '/?section_id=component-cart-drawer',
                      type: 'GET',
                      dataType: 'html',
                      success: function(carthtml){
                           let cartFormHtml = $(carthtml).find('cart-form').prop('outerHTML');
                                 if(window.globalVariables.cart.item_count > 0){
        document.querySelector('.header__icon--cart').classList.add('cart-active');
      } else{
        document.querySelector('.header__icon--cart').classList.remove('cart-active');
      }                   
                          $('cart-form').replaceWith(cartFormHtml);  
                          $('.cart-drawer').addClass('opened-drawer');
                          $('#site-overlay').addClass('overlay--body');
                          $(`#${id}-sample_cart`)
                            .attr('disabled', true) 
                      }
                    })
  }
                  }
              });
          }  
var button_blsVar = $(`.sample_cart_vart_bls`);               
function removeFromCart(id) {
    let prdId = button_blsVar.attr('prdId');
    let varId = button_blsVar.attr('varId');
    if(id == prdId){
      setTimeout(function() {
      $(`#${varId}-sample_cart`).removeAttr('disabled');
      },2000);
    }
}  


function getShipmentDate(number_of_days) {
  const centralTime = new Date(new Date().toLocaleString("en-US", { timeZone: "America/Chicago" }));
  const currentHour = centralTime.getHours();
  const targetHour = window.storeCutoffTime || 0;

  function isWeekend(date) {
    return date.getDay() === 0 || date.getDay() === 6;
  }

  function isHoliday(date) {
		const holidays = window.holidays_list;

		const month = String(date.getMonth() + 1).padStart(2, '0');
		const day = String(date.getDate()).padStart(2, '0');
		const formattedDate = `${month}-${day}`;

		return holidays.includes(formattedDate);
	}

  function getNextBusinessDay(date) {
    const next = new Date(date);
    do {
      next.setDate(next.getDate() + 1);
    } while (isWeekend(next) || isHoliday(next));
    return next;
  }
  let shipmentDate = new Date(centralTime);
  if (!Number(number_of_days)) {
    if (currentHour >= targetHour || isWeekend(shipmentDate) || isHoliday(shipmentDate)) {
      shipmentDate = getNextBusinessDay(shipmentDate);
    }
  } else {
    let daysAdded = 0;
    while (daysAdded < Number(number_of_days)) {
      shipmentDate.setDate(shipmentDate.getDate() + 1);
      if (!isWeekend(shipmentDate) && !isHoliday(shipmentDate)) {
        daysAdded++;
      }
    }
  }
  const formattedDate = shipmentDate.toLocaleString('en-US', {
    month: 'short', 
    day: 'numeric'
  });
  const estimaDiv = document.querySelector('.estima_date');
  if (estimaDiv) {
    estimaDiv.textContent = formattedDate;
  }

  console.log({date: shipmentDate.toLocaleDateString('en-US', {
    month: '2-digit',
    day: "2-digit",
    year: "numeric" 
  })})

  return shipmentDate || null;
}
/*const element_cart = document.querySelector('.number_of_days');
const nuOfDays_cart = element_cart?.innerHTML?.trim();
if (nuOfDays_cart) {
  getShipmentDate(nuOfDays_cart);
}*/

/* Added function to recalculate shipment date across the store */
async function updateShipmentDate() {
  const element_cart = document.querySelector('.number_of_days');
  const nuOfDays_cart = element_cart?.innerHTML?.trim();

  if (!nuOfDays_cart) return null;
  const shipDate = getShipmentDate(nuOfDays_cart);

  console.log({shipDate})

  if(!shipDate) return;

  return await updateCartShipDate(shipDate)
}

/* Function to include shipment date as cart attribute */
async function updateCartShipDate(shpiDate) {
  const formattedShipDate = shpiDate.toLocaleDateString('en-US', {
    month: '2-digit',
    day: "2-digit",
    year: "numeric" 
  })

  const cartUpdateData = {
    'attributes': {
      'ship date': formattedShipDate
    }
  }

  try {
    const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(cartUpdateData)
    });

    return await response.json();
  } catch (error) {
    console.log('Error updating cart', error);
    return null;
  }
}

updateShipmentDate();

// Add To cart button notification
const buttonfirst = document.querySelector('.add_notify_bls');
const totalPriceElement = document.querySelector('.total-price');
if(buttonfirst && totalPriceElement){
buttonfirst.addEventListener('click', () => {
    if (totalPriceElement && totalPriceElement.innerHTML.trim() === '$0.00') {
     const notif = document.querySelector('toast-notification');
        notif.updateNotification(
        "Add to Cart",
        "Please select at least one variant with a quantity.",
        {
          type: "error", 
          timeout: 5000, 
        }
      );
    }
});
} 

let productSlider = null;
let quickShopSlider = null;

window.addEventListener("load", (event) => {
  updateTopinRoot();
  document.querySelectorAll('a[is="drop-down"]').forEach((ele) => {
    new Dropdown(ele);
  });
});
window.addEventListener("resize", (event) => {
  updateTopinRoot();
});

function updateTopinRoot() {
  let detch = document.querySelector("mobile-nav");
  if (detch !== null && detch !== undefined) {
    document.querySelector("body").appendChild(detch);
  }

  let headerEle = document.querySelector(".site-header");
  if (headerEle != undefined) {
    let headerHeight = headerEle.clientHeight;
    document
      .querySelector(":root")
      .style.setProperty("--bs-navdrawer", `${headerHeight}px`);
  }

  let topbarEle = document.querySelector(".topbar");
  if (topbarEle != undefined) {
    let topbarHeight = topbarEle.clientHeight;
    document.documentElement.style.setProperty(
      "--bs-topbar-height",
      `${topbarHeight}px`
    );
  }

  if (window.innerWidth <= 1024) {
    let formdetch = document.querySelector(".search-icon-link > *");
    if (formdetch !== null && formdetch !== undefined) {
      document.querySelector("[data-form-detch]").appendChild(formdetch);
    }
  } else {
    let mobileFormdetch = document.querySelector("[data-form-detch] > *");
    if (mobileFormdetch !== null && mobileFormdetch !== undefined) {
      document.querySelector(".search-icon-link").appendChild(mobileFormdetch);
      document
        .querySelector(".search-icon-link .search-input")
        .setAttribute("disabled", "disabled");
    }
  }
}

/**
 * Dropdown component Events and Methods
 *
 * @param {element} element - Dropdown element
 */
class Dropdown {
  constructor(element) {
    this.element = element;
    this.dropdownParent = element.parentElement;
    this.supportedEvents = [
      "mouseover",
      "focusin",
      "click",
      "mouseout",
      "touchstart",
      "touchend",
    ];
    this.init();
  }

  init() {
    this.supportedEvents.forEach((type) => {
      if (type === "click") {
        this.element.addEventListener(type, (evt) => {
          evt.stopPropagation();
          this.handleDropdownEvent(evt);
        });
      } else if (type === "mouseout" || type === "touchstart") {
        this.dropdownParent.addEventListener(
          type,
          (evt) => {
            let mobileContainer = evt.currentTarget.closest(
              "[data-touch-moveable]"
            );
            if (!mobileContainer) {
              this.dropdownHide(this.dropdownParent, evt.type);
            }
          },
          true
        );
      } else if (type === "mouseover" || type === "focusin") {
        this.dropdownParent.addEventListener(type, (evt) => {
          let mobileContainer = evt.currentTarget.closest(
            "[data-touch-moveable]"
          );
          if (!mobileContainer) {
            this.dropdownShow(this.dropdownParent);
          }
        });
        this.element.addEventListener(type, (_evt) => {
          this.childOnFocusChange(this.dropdownParent);
        });
      } else if (type === "touchend") {
        this.element.addEventListener(type, (evt) => {
          if (this.dropdownParent.closest('[data-role="drawer"]')) {
            evt.preventDefault();
            evt.stopPropagation();
            this.dropdownToggle(this.dropdownParent);
          }
        });
      }
    });

    this.bindEvents();
  }

  bindEvents() {
    let closeBtn = this.dropdownParent.querySelector(".close-submenu");
    if (closeBtn) {
      closeBtn.addEventListener("click", (evt) => {
        evt.preventDefault();
        let parentElement = evt.currentTarget.closest(".dropdown");
        if (parentElement) this.dropdownToggle(parentElement);
      });
    }
  }

  handleDropdownEvent(evt) {
    /* let currentTarget = evt.currentTarget;
    let liveTarget = evt.target;
    if (liveTarget.classList.contains('nav-link-title')) {
      let linkHref = currentTarget.getAttribute('data-href');
      if (linkHref) window.location.href = linkHref;
    } else {*/
    this.dropdownToggle(this.dropdownParent);
    /* } */
  }

  dropdownToggle(dropdownParent) {
    setTimeout(() => {
      dropdownParent.classList.contains("open")
        ? this.dropdownHide(dropdownParent)
        : this.dropdownShow(dropdownParent);
    }, 50);
  }

  dropdownShow(dropdownParent) {
    if (!dropdownParent) {
      return;
    }
    this.element.setAttribute("aria-expanded", true);
    if (!dropdownParent.closest('[data-role="drawer"]')) {
      dropdownParent.classList.add("open");
    } else {
      Utility.toggleElement(dropdownParent, "open");
    }
    if (dropdownParent.classList.contains("megamenu")) {
      dropdownParent.querySelectorAll(".mega-menu-tab").forEach((ele) => {
        ele.addEventListener("mouseover", (evt) => {
          dropdownParent
            .querySelector(".mega-menu-tab.active")
            .classList.remove("active");
          evt.currentTarget.classList.add("active");

          let id = evt.currentTarget.getAttribute("data-title-href");
          dropdownParent
            .querySelector(".megamenu-wrapper.open")
            .classList.remove("open");
          dropdownParent.querySelector(`${id}`).classList.add("open");
        });
      });
    }
  }

  dropdownHide(dropdownParent, eventType) {
    if (!dropdownParent) {
      return;
    }
    this.element.setAttribute("aria-expanded", false);
    if (!dropdownParent.closest('[data-role="drawer"]')) {
      dropdownParent.classList.remove("open");
    } else {
      Utility.toggleElement(dropdownParent, "close");
    }

    if (
      eventType === "mouseout" &&
      dropdownParent.parentElement.closest(".dropdown")
    ) {
      dropdownParent.parentElement
        .closest(".dropdown")
        .classList.remove("open");
    }

    let childDropdowns = dropdownParent.querySelectorAll(".dropdown.open");
    if (childDropdowns.length > 0) {
      childDropdowns.forEach((child) => {
        child.classList.remove("open");
        if (child.querySelector('a[data-toggle="open"]'))
          child
            .querySelector('a[data-toggle="open"]')
            .setAttribute("aria-expanded", false);
      });
    }
  }

  childOnFocusChange(dropdownParent) {
    let openDropdowns = Array.from(
      dropdownParent.parentElement.querySelectorAll(".dropdown.open")
    );
    let currentIndex = openDropdowns.indexOf(dropdownParent);
    openDropdowns.forEach((ele) => {
      let eleIndex = openDropdowns.indexOf(ele);
      if (eleIndex !== currentIndex) {
        this.dropdownHide(ele);
      }
    });
  }
}

/**
 * Close SubMenu Dropdowns on Regular Nav Item fous or click
 *
 * @param {element} element - Dropdown element
 */
class DefaultNavItem {
  constructor(element) {
    this.element = element;
    this.supportedEvents = [
      "mouseover",
      "focusin",
      "click",
      "mouseout",
      "touchstart",
    ];
    this.init();
  }

  init() {
    let _this = this.element;
    this.supportedEvents.forEach((type) => {
      _this.addEventListener(type, (e) => {
        e.stopPropagation();
        let currentTarget = e.currentTarget;
        if (!currentTarget.closest("[data-touch-moveable]")) {
          this.hideDropdown(currentTarget.parentElement);
        }
      });
    });

    _this.addEventListener("touchend", (e) => {
      e.stopPropagation();
    });
  }

  hideDropdown(dropdownParent) {
    let openDropdowns = Array.from(
      dropdownParent.parentElement.querySelectorAll(".dropdown.open")
    );
    openDropdowns.forEach((ele) => {
      ele.classList.remove("open");
      ele
        .querySelector('[is="drop-down"]')
        .setAttribute("aria-expanded", false);
    });
  }
}
const allDefaultNav = document.querySelectorAll('a[is="simple-menu-item"]');
allDefaultNav.forEach((ele) => {
  new DefaultNavItem(ele);
});

/**
 * Search component Events and Methods
 *
 * @param {element} element - Search element
 */
class Search {
  constructor(element) {
    this.element = element;
    this.init();
  }
  init() {
    if (this.element) {
      this.element.addEventListener("click", (evt) => {
        evt.currentTarget.closest(".search-icon-link").classList.add("active");
        evt.currentTarget
          .closest(".search-icon-link")
          .querySelector(".search-input")
          .removeAttribute("disabled");
        Utility.forceFocus(document.getElementById("Search-In-Modal"));
      });
    }
    if (
      this.element
        .closest(".search-icon-link")
        .querySelector("[data-search-close]")
    ) {
      this.element
        .closest(".search-icon-link")
        .querySelector("[data-search-close]")
        .addEventListener("click", (evt) => {
          evt.preventDefault();
          evt.currentTarget
            .closest(".search-icon-link")
            .classList.remove("active");
          evt.currentTarget
            .closest(".search-icon-link")
            .querySelector(".search-input").value = "";
          evt.currentTarget
            .closest(".search-icon-link")
            .querySelector(".search-input")
            .setAttribute("disabled", "disabled");
          Utility.removeTrapFocus();
          if (
            evt.currentTarget
              .closest(".search-icon-link")
              .querySelector("[data-predictive-search]")
          ) {
            evt.currentTarget
              .closest(".search-icon-link")
              .querySelector("[data-predictive-search]")
              .classList.remove("show-results");
            evt.currentTarget
              .closest(".search-icon-link")
              .querySelector("[data-predictive-search]").innerHTML = "";
          }
        });
    }
  }
}
if (window.innerWidth >= 1025) {
  const allSearchs = document.querySelectorAll("[data-search-trigger]");
  allSearchs.forEach((ele) => {
    new Search(ele);
  });
}

/**
 * background Overlay
 */
class siteOverlay extends HTMLElement {
  constructor() {
    super();

    this.menuDrawer = document.querySelector("#mobile-menu-drawer");
    this.cartDrawer = document.querySelector("#ajax-cart");
    this.searchDrawer = document.querySelector("search-modal");

    this.bindEvents();
  }

  connectedCallback() {}

  /**
   * bind Click and Touchend event to this custom component
   */
  bindEvents() {
    this.addEventListener("click", this.onClick.bind(this));
    this.addEventListener("touchend", this.onClick.bind(this));
  }

  /**
   * Click event of Site overlay
   * @param {event} Event instance performed
   */
  onClick(event) {
    const closeCart =
      this.cartDrawer && this.cartDrawer.classList.contains("opened-drawer");
    const closeMenu =
      this.menuDrawer && this.menuDrawer.classList.contains("opened-drawer");
    const closeSearch =
      this.searchDrawer && this.searchDrawer.classList.contains("open__modal");

    if (closeCart)
      document
        .querySelector(".close-ajax--cart")
        .dispatchEvent(new Event("click"));
    if (closeMenu)
      document
        .querySelector(".close-mobile--navbar")
        .dispatchEvent(new Event("click"));
    if (closeSearch)
      document.querySelector(".search-close").dispatchEvent(new Event("click"));

    this.hideOverlay();
  }

  /**
   * Show Overlay
   */
  showOverlay() {
    document.querySelector("#site-overlay").classList.add("overlay--body");
    document.body.classList.add("scroll-fixed");
  }

  /**
   * Hide overlay
   */
  hideOverlay() {
    document.querySelector("#site-overlay").classList.remove("overlay--body");
    document.body.classList.remove("scroll-fixed");
  }
}
customElements.define("site-overlay", siteOverlay, {
  once: true,
});

/**
 * Slider Component
 *
 */
class sliderElement extends HTMLElement {
  constructor() {
    super();
    this.sliderEle = this.querySelector(".swiper-slider");
    this.sliderOptions = JSON.parse(this.sliderEle.getAttribute("data-slider"));
  }

  static get observedAttributes() {
    return ["data-slider"];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "data-slider" && newValue) {
      this.sliderOptions = JSON.parse(newValue);
    }
  }

  connectedCallback() {
    if (!this.sliderEle) return;

    let thumbSlider = null;

    // Set up nav slider
    if (this.sliderEle.hasAttribute("data-nav")) {
      thumbSlider = document.querySelector(
        `.${this.sliderEle.getAttribute("data-nav")}`
      );
      if (!thumbSlider) {
        return;
      }

      const thumbSliderOptions = JSON.parse(
        thumbSlider.getAttribute("data-slider")
      );
      thumbSlider = new Swiper(thumbSlider, thumbSliderOptions);
      this.sliderOptions.thumbs = {
        swiper: thumbSlider,
      };
    }

    const sliderInstance = new Swiper(this.sliderEle, this.sliderOptions);

    if (this.sliderEle.classList.contains("product-carousel")) {
      productSlider = sliderInstance;
    } else if (this.sliderEle.classList.contains("quickshop-slider")) {
      quickShopSlider = sliderInstance;
    }

    this.slideChangeEvt(sliderInstance, thumbSlider);
  }

  slideChangeEvt(slider, thumbSlider) {
    slider.on("slideChange", (event) => {
      if (thumbSlider) thumbSlider.slideTo(slider.activeIndex);

      const activeVideos = slider.el.querySelectorAll(
        ".custom-video-container.playing--video"
      );

      if (activeVideos.length > 0) {
        activeVideos.forEach((container) => {
          let video = container.querySelector("custom-video");
          let videoType = video.getAttribute("data-video-type");
          let videoEle =
            video.querySelector("video") || video.querySelector("iframe");
          if (videoType == "local") {
            videoEle.pause();
          } else if (videoType == "youtube") {
            videoEle.contentWindow.postMessage(
              '{"event":"command","func":"pauseVideo","args":""}',
              "*"
            );
          }
        });
      }
    });
  }
}
let lookForSwiper = setInterval(() => {
  if (typeof Swiper == "function") {
    customElements.define("slider-element", sliderElement);
    clearInterval(lookForSwiper);
  }
}, 100);

/**
 * Custom Video
 */
class customVideo extends HTMLElement {
  constructor() {
    super();

    this.type = this.getAttribute("data-video-type");
    this.videoURL = this.getAttribute("data-video-id");
    this.placementType = this.getAttribute("data-placement");
    this.videoStatus = "empty";

    this.container = this.closest(".custom-video-container");
    this.videoModal = document.getElementById("PopupModal-video");
    this.contentSection = this.querySelector(".content-section");
    this.videoSection = this.querySelector(".video-section");
    if (this.placementType == "popup")
      this.videoSection = this.videoModal.querySelector(".video-container");
    this.triggerVideo = this.container.querySelector("[data-trigger-video]");

    this.bindEvents();
  }

  connectedCallback() {
    // Connected callback
  }

  /**
   * Binding events on the video button
   */
  bindEvents() {
    if (this.querySelector("[data-postervideo]")) this.managePosterVideos();
    if (this.triggerVideo)
      this.triggerVideo.addEventListener("click", this.toggleView.bind(this));
    if (this.placementType == "grid")
      this.addEventListener("focusout", this.focusOut.bind(this));
  }

  /**
   * Focus Out Event to close drawer
   *
   * @param {event} Event instance
   */
  focusOut(event) {
    if (this.container.classList.contains("playing--video")) this.toggleView();
  }

  /**
   * Toggle of video modal
   */
  toggleView(_event) {
    let isOpen = this.container.classList.contains("playing--video");
    if (isOpen) {
      this.container.classList.remove("playing--video");
    } else {
      if (this.videoStatus == "empty" || this.placementType == "popup") {
        const videoElement = this._buildVideo();
        videoElement.id = "custom-video" + Math.floor(Math.random() * 100 + 1);
        this.videoSection.appendChild(videoElement);
        this.videoStatus = "loaded";

        setTimeout(() => {
          this.placementType == "popup"
            ? openModal(this.videoModal, this.triggerVideo)
            : this.container.classList.add("playing--video");
          this.pauseOnVisibilityChange(videoElement);
          this._playVideo(videoElement);
        }, 700);
      } else {
        const videoElement =
          this.querySelector(".video-section video") ||
          this.querySelector(".video-section iframe");
        this.container.classList.add("playing--video");
        this._playVideo(videoElement);
      }
    }
  }

  _playVideo(video) {
    if (this.type == "local") {
      video.play();
    } else if (this.type == "youtube") {
      video.contentWindow.postMessage(
        '{"event":"command","func":"playVideo","args":""}',
        "*"
      );
    }
  }

  /**
   *
   * Create the video html element
   */
  _buildVideo() {
    let video;

    if (this.type == "local") {
      video = document.createElement("video");
      video.src = this.videoURL;
      if (this.dataset.controls == "true")
        video.controls = this.dataset.controls;
      if (this.dataset.muted == "true") video.muted = this.dataset.muted;
      if (this.dataset.autoplay == "true")
        video.autoplay = this.dataset.autoplay;
      if (this.dataset.loop == "true") video.loop = this.dataset.loop;
      video.playsInline = true;
    } else if (this.type == "youtube") {
      let videoID = this.videoURL.replace(
        "https://www.youtube.com/watch?v=",
        ""
      );
      video = document.createElement("iframe");
      video.setAttribute("allowfullscreen", "");
      video.setAttribute("frameborder", "0");
      video.setAttribute("allow", "autoplay");
      video.setAttribute(
        "src",
        "https://www.youtube.com/embed/" +
          videoID +
          `?rel=0&showinfo=0&autoplay=${this.dataset.autoplay}&muted=${this.dataset.muted}&controls=${this.dataset.controls}&loop=${this.dataset.loop}&playlist=${videoID}&enablejsapi=1&origin=${window.origin}`
      );
    }
    return video;
  }

  /**
   * Pause video on scroll when out of viewport
   *
   */
  pauseOnVisibilityChange(videoEle) {
    let scrollObserver = new IntersectionObserver((entries) => {
      if (
        (this.type == "local" && videoEle == undefined) ||
        (this.type == "youtube" && videoEle.contentWindow == null)
      ) {
        scrollObserver.disconnect();
        return;
      }

      entries.forEach((entry) => {
        if (entry.intersectionRatio == 0) {
          if (this.type == "local") {
            videoEle.pause();
          } else if (this.type == "youtube") {
            videoEle.contentWindow.postMessage(
              '{"event":"command","func":"pauseVideo","args":""}',
              "*"
            );
          }
        }
      });
    });
    scrollObserver.observe(videoEle);
  }

  /**
   * Poster Video Autoplay
   *
   */
  managePosterVideos() {
    let posterVideo = this.querySelector("[data-postervideo]");
    if (!posterVideo || posterVideo == undefined) return;

    const videoIntersection = (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting && entry.target) {
          let sourceTag = document.createElement("source");
          sourceTag.src = entry.target.dataset.src;
          sourceTag.type = "video/mp4";
          entry.target.appendChild(sourceTag);
          entry.target.play();
          observerPosterVideo.disconnect();
        }
      }
    };
    const observerPosterVideo = new IntersectionObserver(videoIntersection);
    observerPosterVideo.observe(posterVideo);
  }
}
customElements.define("custom-video", customVideo);

/**
 * Open Modal javscript trigger
 *
 * */
function openModal(modal, opener) {
  if (modal && opener != undefined) modal.show(opener);
}

/**
 * Modal Dialogue
 *
 */
class ModalDialog extends HTMLElement {
  constructor() {
    super();

    this.modal = this.querySelector(".modal");
    this.modalOpeners = [
      ...document.querySelectorAll(`[data-modal-opener="${this.id}"]`),
    ];
    this.closeBtn = this.querySelector('[id^="ModalClose-"]');
  }

  connectedCallback() {
    this.modalOpeners.forEach((opener) => {
      opener.addEventListener("click", (evt) => {
        evt.preventDefault();
        this.show(opener);
      });
    });

    if (this.closeBtn) {
      this.closeBtn.addEventListener("click", this.hide.bind(this));
    }

    this.addEventListener("click", (evt) => {
      if (evt.target.nodeName === "MODAL-DIALOG") this.hide();
    });

    this.addEventListener("keyup", (evt) => {
      if (evt.code && evt.code.toUpperCase() === "ESCAPE") this.hide();
    });
  }

  /**
   * Open the Modal
   * @param {element} opener
   */
  show(opener) {
    this.openedBy = opener;
    this.modal.classList.add("open");
    siteOverlay.prototype.showOverlay();
    Utility.trapFocus(this);
    Utility.forceFocus(this.closeBtn);
  }

  /**
   * Close Modal Dialogue
   */
  hide() {
    this.modal.classList.remove("open");
    siteOverlay.prototype.hideOverlay();
    Utility.removeTrapFocus(this.openedBy);

    if (this.id == "PopupModal-video") {
      this.querySelector(".video-container").innerHTML = "";
    }
  }
}
customElements.define("modal-dialog", ModalDialog);

/**
 * Manage Custom Notification Trigger
 *
 */
class Notification extends HTMLElement {
  constructor() {
    super();

    this.container = this.querySelector(".snotifyToast");
    this.closeBtn = this.querySelector(".snotifyToast__close");
    this.animateNotifcation = null;
  }

  connectedCallback() {
    if (this.closeBtn) {
      this.closeBtn.addEventListener("click", (e) => {
        e.preventDefault();
        this.hide();
      });
    }
  }

  /**
   * Notification Type
   * @param title
   * @param body
   * @param options
   */
  updateNotification(title, body, options) {
    this.querySelector(".snotifyToast__title").textContent = title;
    this.querySelector(".snotifyToast__body").textContent = body;

    this.container.classList.add("open", `snotify-${options.type}`);
    this._manageToggle(options.timeout);
  }

  /**
   * Duration of notification to hide again
   * @param timeout
   */
  _manageToggle(timeout) {
    this.progressBar = this.querySelector("[data-toast-pr]");
    const totalFrames = Math.ceil(timeout / 16.67) / 2;
    let frame = 0;
    let width = 0;

    this.animateNotifcation = () => {
      width = (frame / totalFrames) * 100;
      this.progressBar.setAttribute("style", `width: ${width}%`);
      if (frame < totalFrames) {
        frame++;
        requestAnimationFrame(this.animateNotifcation);
      } else {
        this.closeBtn.dispatchEvent(new Event("click"));
      }
    };
    requestAnimationFrame(this.animateNotifcation);
  }

  hide() {
    cancelAnimationFrame(this.animateNotifcation);
    this.container.className = "snotifyToast";
    [
      this.querySelector(".snotifyToast__title"),
      this.querySelector(".snotifyToast__body"),
    ].forEach((ele) => (ele.textContent = ""));
    this.querySelector("[data-toast-pr]").removeAttribute("style");
  }
}
customElements.define("toast-notification", Notification);
window.notificationEle = document.querySelector("toast-notification");
// notificationEle.updateNotification('Title', 'Body', {
//   type: 'success',
//   timeout: 5000
// });

/**
 * ReadMore Text
 *
 */
class ReadMore extends HTMLElement {
  constructor() {
    super();

    this.trigger = this.querySelector("[data-read-trigger]");
  }
  connectedCallback() {
    let offsetHeight = this.querySelector(".readmore-wrapper").offsetHeight;
    let scrollHeight = this.querySelector(".readmore-wrapper").scrollHeight;

    if (scrollHeight == offsetHeight) {
      this.trigger.classList.add("d-none");
      this.trigger.classList.remove("d-inline-block");
    } else {
      this.querySelector(".readmore-wrapper").style.height =
        offsetHeight + "px";
      this.trigger.addEventListener("click", (evt) => {
        evt.preventDefault();
        this.show(evt, scrollHeight, offsetHeight);
      });
    }
  }
  /**
   * Open the Text
   * @param {element} opener
   */
  show(opener, scrollHeight, offsetHeight) {
    if (this.querySelector(".readmore-wrapper").classList.contains("open")) {
      this.querySelector(".readmore-wrapper").style.height =
        offsetHeight + "px";
      opener.target.innerHTML = "Read More";
      let _this = this;
      setTimeout(function () {
        _this.querySelector(".readmore-wrapper").classList.remove("open");
      }, 200);
    } else {
      this.querySelector(".readmore-wrapper").classList.add("open");
      let newscrollHeight =
        this.querySelector(".readmore-wrapper").scrollHeight;
      this.querySelector(".readmore-wrapper").style.height =
        newscrollHeight + "px";
      opener.target.innerHTML = "Read Less";
    }
  }
}
customElements.define("custom-readmore", ReadMore);
/**
 * ScrollSpy
 *
 */
class ScrollSpy {
  constructor() {
    this.sectionLinks = document.querySelectorAll("[data-scrollspy] a");
    this.updateActiveSections = this.updateActiveSections.bind(this);
    window.addEventListener("load", () => {
      this.initialize();
    });
    window.addEventListener("resize", () => {
      this.initialize();
    });
  }

  initialize() {
    this.updateActiveSections();
    window.addEventListener("scroll", this.updateActiveSections);
  }

  updateActiveSections() {
    const scrollPosition = window.scrollY;
    const allLinks = this.sectionLinks;

    allLinks.forEach((sectionLink) => {
      const container = document.querySelector(
        sectionLink.getAttribute("href")
      );
      if (container) {
        // Ensure the container exists
        const containerOffset =
          container.getBoundingClientRect().top + scrollPosition;
        const containerHeight = container.offsetHeight;
        const containerBottom = containerOffset + containerHeight;

        if (
          scrollPosition < containerBottom - 125 &&
          scrollPosition >= containerOffset - 125
        ) {
          if (!sectionLink.classList.contains("active")) {
            sectionLink.classList.add("active");
          }
        } else {
          sectionLink.classList.remove("active");
        }
      }
    });

    // Fallback in case no section link is active
    setTimeout(() => {
      if (
        !Array.from(allLinks).some((link) => link.classList.contains("active"))
      ) {
        if (allLinks[0]) {
          allLinks[0].classList.add("active");
        }
      }
    }, 300);
  }
}

const scrollSpy = new ScrollSpy();

// On iPhone, when we click on any input, The page zoom issue is fixed now
if (navigator.userAgent.indexOf("iPhone") > -1) {
  document
    .querySelector("[name=viewport]")
    .setAttribute(
      "content",
      "width=device-width, initial-scale=1, maximum-scale=1"
    );
}